import React, { useEffect, useState } from 'react'

const STORAGE_KEY = 'fw_cookie_consent_v1'

export default function CookieBanner() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    try {
      const val = localStorage.getItem(STORAGE_KEY)
      if (!val) setVisible(true)
    } catch {
      setVisible(true)
    }
  }, [])

  if (!visible) return null

  return (
    <div data-testid="cookie-banner" className="fixed bottom-4 left-4 z-50">
      <div className="p-4 rounded-lg shadow-lg bg-white border border-gray-200 w-[22rem] max-w-[90vw]">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <p className="text-sm text-gray-700">
            Diese Website verwendet nur technisch notwendige Cookies. Sie sind erforderlich, damit Sie sich anmelden und das Portal sicher nutzen können. Mehr erfahren in der{' '}
            <a href="/datenschutz" className="underline text-blue-600 hover:text-blue-700">Datenschutzerklärung</a>.
          </p>
          <div className="flex gap-2">
            <button
              onClick={() => { try { localStorage.setItem(STORAGE_KEY, 'accepted') } catch {}; setVisible(false) }}
              className="px-4 py-2 rounded bg-blue-600 text-white text-sm hover:bg-blue-700"
            >
              Verstanden
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
